function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { StyledButtonBase, Icon, Logo } from "../";
export const ButtonSocial = ({
  children,
  platform,
  reverse,
  ...props
}) => {
  const isReverse = reverse || platform === "Google";
  return /*#__PURE__*/React.createElement(StyledButtonSocial, _extends({
    platform: platform,
    reverse: isReverse,
    variant: isReverse ? "tertiary" : "primary"
  }, props), isReverse ? /*#__PURE__*/React.createElement(StyledLogo, {
    name: `${platform}Default`
  }) : /*#__PURE__*/React.createElement(StyledIcon, {
    tertiary: true,
    name: platform
  }), children);
};
const StyledLogo = styled(Logo)`
  margin-right: 8px;
  width: 16px;
  height: 16px;
`;
const StyledIcon = styled(Icon)`
  margin-right: 8px;
`;
const StyledButtonSocial = styled(StyledButtonBase)`
  ${props => !props.reverse && props.theme.buttonSocial.global};
  ${props => !props.reverse && props.theme.buttonSocial[props.platform?.toLowerCase()]};

  &&:hover,
  &&:focus {
    ${props => !props.reverse && props.theme.buttonSocial.global.hover};
    ${props => !props.reverse && props.theme.buttonSocial[props.platform?.toLowerCase()]?.hover};
  }
`;